// import React, { useEffect, useState } from "react";
// import { useOutletContext } from "react-router-dom";
// import "./ServitorRewards.css";
// import { FaGift, FaLock, FaTrophy, FaHistory } from "react-icons/fa";
// import { useTranslation } from "react-i18next";
// import toast, { Toaster } from "react-hot-toast";

// const ServitorRewards = () => {
//   const { t } = useTranslation("servitor");
//   const { servitor } = useOutletContext();
//   const [rewards, setRewards] = useState({
//     rewardPoints: 0,
//     lifetimeRewardPoints: 0,
//     canClaim: false,
//     threshold: 100,
//   });
//   const [loading, setLoading] = useState(true);
//   const [claimLoading, setClaimLoading] = useState(false);
//   const [history, setHistory] = useState([]);

//   // Fetch rewards summary + history
  
//   useEffect(() => {
//     if (!servitor?.Id) return;

//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const res = await fetch(
//           `http://localhost:4001/rewards/servitors/${servitor.Id}/summary`
//         );
//         const data = await res.json();
//         setRewards(data || {});

//         const histRes = await fetch(
//           `http://localhost:4001/rewards/servitors/${servitor.Id}/history`
//         );
//         const histData = await histRes.json();
//         setHistory(histData || []);
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [servitor]);

//   const showToast = (msg, type) => {
//     toast[type](msg, { position: "top-right", duration: 3000 });
//   };

//   const handleClaim = async () => {
//     if (!servitor?.Id) return;
//     if (rewards.rewardPoints < rewards.threshold) {
//       showToast(
//         t("reward.requirementShort", { threshold: rewards.threshold }),
//         "error"
//       );
//       return;
//     }

//     try {
//       setClaimLoading(true);
//       const res = await fetch(
//         `http://localhost:4001/rewards/servitors/${servitor.Id}/claim`,
//         { method: "POST", headers: { "Content-Type": "application/json" } }
//       );
//       const data = await res.json();

//       if (!res.ok) {
//         showToast(data?.message || "Claim failed", "error");
//       } else {
//         showToast(t("reward.claimSuccess", { amount: data.addedTaka }), "success");
//         setRewards((r) => ({
//           ...r,
//           rewardPoints: 0,
//           canClaim: false,
//         }));
//       }
//     } catch (e) {
//       console.error(e);
//       showToast("Claim failed", "error");
//     } finally {
//       setClaimLoading(false);
//     }
//   };

//   const points = rewards.rewardPoints || 0;
//   const threshold = rewards.threshold || 100;
//   const progress = Math.min(100, Math.round((points / threshold) * 100));
//   const remaining = Math.max(0, threshold - points);
//   const canClaimNow = points >= threshold;

//   if (loading) {
//     return <div className="rewards-loading">Loading rewards...</div>;
//   }

//   return (
//     <div className="servitor-rewards-page">
//       <Toaster />
//       <div className="rewards-header">
//         <FaGift className="rewards-header-icon" />
//         <h2>{t("reward.title")}</h2>
//       </div>

//       <div className="rewards-summary-cards">
//         <div className="rewards-card main">
//           <div className="rewards-card-icon">
//             <FaTrophy />
//           </div>
//           <div className="rewards-card-content">
//             <h3>{t("reward.currentPoints")}</h3>
//             <p className="rewards-points-value">{points}</p>
//             <div className="rewards-progress">
//               <div
//                 className="rewards-progress-fill"
//                 style={{ width: `${progress}%` }}
//               ></div>
//             </div>
//             <p className="rewards-progress-text">
//               {points}/{threshold} pts ({progress}%)
//             </p>
//             <p className="rewards-remaining-text">
//               {remaining > 0
//                 ? t("reward.needed", { remaining })
//                 : t("reward.ready")}
//             </p>
//             <button
//               className={`rewards-claim-btn ${
//                 !canClaimNow || claimLoading ? "locked" : ""
//               }`}
//               disabled={!canClaimNow || claimLoading}
//               onClick={handleClaim}
//             >
//               {!canClaimNow && <FaLock />}
//               {claimLoading
//                 ? t("reward.claiming")
//                 : canClaimNow
//                 ? t("reward.claimNow")
//                 : t("reward.requirementShort", { threshold })}
//             </button>
//           </div>
//         </div>

//         <div className="rewards-card">
//           <h3>{t("reward.lifetime")}</h3>
//           <p className="rewards-lifetime">{rewards.lifetimeRewardPoints} pts</p>
//         </div>
//       </div>

//       {history.length > 0 && (
//         <div className="rewards-history">
//           <h3>
//             <FaHistory style={{ marginRight: "8px" }} />
//             {t("reward.history")}
//           </h3>
//           <table>
//             <thead>
//               <tr>
//                 <th>{t("reward.date")}</th>
//                 <th>{t("reward.points")}</th>
//                 <th>{t("reward.status")}</th>
//               </tr>
//             </thead>
//             <tbody>
//               {history.map((h, idx) => (
//                 <tr key={idx}>
//                   <td>{new Date(h.date).toLocaleDateString()}</td>
//                   <td>{h.points}</td>
//                   <td>{h.status}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ServitorRewards;






import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import "./ServitorRewards.css";
import { FaGift, FaLock, FaTrophy, FaHistory } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import toast, { Toaster } from "react-hot-toast";
import { URL } from "../../config";
import Loader from "../../Components/LoaderSpin/Loader";

const ServitorRewards = () => {
  const { t } = useTranslation("servitor");
  const { servitor } = useOutletContext();
  const [rewards, setRewards] = useState({
    rewardPoints: 0,
    lifetimeRewardPoints: 0,
    canClaim: false,
    threshold: 100,
  });
  const [loading, setLoading] = useState(true);
  const [claimLoading, setClaimLoading] = useState(false);
  const [history, setHistory] = useState([]);

  // Fetch rewards summary + history
  useEffect(() => {
    if (!servitor?.Id) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `${URL}/rewards/servitors/${servitor.Id}/summary`
        );
        const data = await res.json();
        setRewards(data || {});

        const histRes = await fetch(
          `${URL}/rewards/servitors/${servitor.Id}/history`
        );
        const histData = await histRes.json();
        setHistory(histData || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [servitor]);

  const showToast = (msg, type) => {
    toast[type](msg, { position: "top-right", duration: 3000 });
  };


 // Format: 30-september-2025 by default (avoids TZ shift for YYYY-MM-DD)
const formatHistoryDate = (input, { fullYear = true } = {}) => {
  if (!input && input !== 0) return "";
  const s = String(input).trim();

  // Handle "YYYY-MM-DD" safely (no timezone shift)
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  let y, mo, d;
  if (m) {
    y = parseInt(m[1], 10);
    mo = parseInt(m[2], 10);
    d = parseInt(m[3], 10);
  } else {
    const dt = new Date(s);
    if (isNaN(dt.getTime())) return s; // fallback to raw string
    y = dt.getFullYear();
    mo = dt.getMonth() + 1;
    d = dt.getDate();
  }

  const monthsFullLower = [
    "january","february","march","april","may","june",
    "july","august","september","october","november","december"
  ];
  const monthName = monthsFullLower[mo - 1] || "";

  const yearOut = fullYear ? y : String(y).slice(-2);
  return `${d}-${monthName}-${yearOut}`;
};



  const handleClaim = async () => {
    if (!servitor?.Id) return;
    const threshold = rewards.threshold || 100;
    if ((rewards.rewardPoints || 0) < threshold) {
      showToast(t("reward.requirementShort", { threshold }), "error");
      return;
    }

    try {
      setClaimLoading(true);
      const res = await fetch(
        `${URL}/rewards/servitors/${servitor.Id}/claim`,
        { method: "POST", headers: { "Content-Type": "application/json" } }
      );
      const data = await res.json();

      if (!res.ok) {
        showToast(data?.message || "Claim failed", "error");
      } else {
        showToast(t("reward.claimSuccess", { amount: data.addedTaka }), "success");
        setRewards((r) => ({
          ...r,
          rewardPoints: 0,
          canClaim: false,
        }));
      }
    } catch (e) {
      console.error(e);
      showToast("Claim failed", "error");
    } finally {
      setClaimLoading(false);
    }
  };

  const points = rewards.rewardPoints || 0;
  const threshold = rewards.threshold || 100;
  const progress = Math.min(100, Math.round((points / threshold) * 100));
  const remaining = Math.max(0, threshold - points);
  const canClaimNow = points >= threshold;

  // if (loading) {
  //   return (
  //     <div className="servitorrewards-page">
  //       <div className="servitorrewards-skeleton">
  //         <div className="servitorrewards-skel-title" />
  //         <div className="servitorrewards-skel-row">
  //           <div className="servitorrewards-skel-card" />
  //         </div>
  //         <div className="servitorrewards-skel-table" />
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="servitorrewards-page">
      <Loader show={loading} />
      <Toaster />

      {/* Header (no top-right CTA anymore) */}
      <div className="servitorrewards-header">
        <div className="servitorrewards-title">
          <FaGift className="servitorrewards-title-icon" />
          <div>
            <h2>{t("reward.title")}</h2>
            <p className="servitorrewards-subtitle">
              {t("reward.tagline", { progress, remaining })}
            </p>
          </div>
        </div>
      </div>

      {/* Single compact rewards card */}
      <div className="servitorrewards-summary">
        <div className="servitorrewards-single">
          <div
            className="servitorrewards-card servitorrewards-card--main"
            role="status"
            aria-label={t("reward.currentPoints")}
          >
            <div className="servitorrewards-card-top">
              <div className="servitorrewards-card-icon">
                <FaTrophy />
              </div>
              <span className="servitorrewards-kicker">{t("reward.currentPoints")}</span>
            </div>

            <div className="servitorrewards-metrics">
              <span className="servitorrewards-points">{points}</span>
              <span className="servitorrewards-slash">/</span>
              <span className="servitorrewards-threshold">{threshold}</span>
              <span className="servitorrewards-unit">pts</span>
            </div>

            {/* Full-width progress bar: fill = emerald, gap = white */}
            <div
              className="servitorrewards-progress"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={progress}
            >
              <div
                className="servitorrewards-progress-fill"
                style={{ width: `${progress}%` }}
              />
            </div>

            <div className="servitorrewards-progress-row">
              <span className="servitorrewards-progress-text">
                {remaining > 0
                  ? t("reward.needed", { remaining })
                  : t("reward.ready")}
              </span>
            </div>

            {/* Full-width centered CTA */}
            <button
              className={`servitorrewards-claimbtn servitorrewards-claimbtn--block ${
                !canClaimNow || claimLoading ? "is-disabled" : ""
              }`}
              disabled={!canClaimNow || claimLoading}
              onClick={handleClaim}
            >
              {!canClaimNow && <FaLock />}
              {claimLoading
                ? t("reward.claiming")
                : canClaimNow
                ? t("reward.claimNow")
                : `${t("reward.claimNowLabel")} (${t("reward.needX", { x: threshold })})`}
            </button>
          </div>
        </div>
      </div>

      {/* History with smaller Lifetime badge on top-right */}
      <section className="servitorrewards-history">
        <div className="servitorrewards-history-head">
          <div className="servitorrewards-history-title">
            <FaHistory />
            <h3>{t("reward.history")}</h3>
          </div>

          <div className="servitorrewards-lifetime-badge" title={t("reward.lifetimeFull")}>
            <span className="servitorrewards-lifetime-label">{t("reward.lifetimeShort")}</span>
            <span className="servitorrewards-lifetime-value">
              {rewards.lifetimeRewardPoints} {t("reward.pts")}
            </span>
          </div>
        </div>

        {history.length > 0 ? (
          <div className="servitorrewards-tablewrap">
            <table className="servitorrewards-table">
              <thead>
                <tr>
                  <th>{t("reward.date")}</th>
                  <th>{t("reward.points")}</th>
                  <th>{t("reward.status")}</th>
                </tr>
              </thead>
              <tbody>
                {history.map((h, idx) => (
                  <tr key={idx}>
                    {/* <td>{new Date(h.date).toLocaleDateString()}</td> */}
                    <td>{formatHistoryDate(h.date)}</td>
                    <td>{h.points}</td>
                    <td
                      className={`servitorrewards-status servitorrewards-status--${String(
                        h.status
                      ).toLowerCase()}`}
                    >
                      {h.status}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="servitorrewards-empty">
            <FaHistory />
            <p>{t("reward.emptyHistory")}</p>
          </div>
        )}
      </section>
    </div>
  );
};

export default ServitorRewards;
